import React, { useState, useEffect } from "react";

function TestOtp() {
  const [Otp, setOtp] = useState("");

  useEffect(() => {
    if ("OTPCredential" in window) {
      const ac = new AbortController();
      
      navigator.credentials
        .get({
          otp: { transport: ['sms'] },
          signal: ac.signal,
        })
        .then((otp) => {
          setOtp(otp.code);
          ac.abort();
        })
        .catch((err) => {
          ac.abort();
          alert(err);
        });
    }
    
    function showPosition(position) {
      console.log("position", position.coords)
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      console.log("Not supported")
      // x.innerHTML = "Geolocation is not supported by this browser.";
    }
    
  },[]);


  return (
    <div>
      <div> Here is the : {Otp}</div>
      <button >Read OTP</button>
    </div>
  );
}

export default {
  component: TestOtp,
};